import { PasswordValidation } from '../types';

const checkPasswordValidHelper = (
  password: string,
  passwordValidation: PasswordValidation,
  setPasswordIsValid: (data: boolean) => void,
  passwordIsValid: boolean,
  setPasswordValidation: (data: PasswordValidation) => void,
) => {
  const nextPasswordValidation = { ...passwordValidation };

  if (/[A-Z]/.test(password)) {
    nextPasswordValidation.hasUpper = true;
  } else if (nextPasswordValidation.hasUpper && !/[A-Z]/.test(password)) {
    nextPasswordValidation.hasUpper = false;
  }

  if (/[0-9]/.test(password)) {
    nextPasswordValidation.hasNumber = true;
  } else if (nextPasswordValidation.hasNumber && !/[0-9]/.test(password)) {
    nextPasswordValidation.hasNumber = false;
  }

  if (/[!#$%&*~_+=]/.test(password)) {
    nextPasswordValidation.hasSpecialCharacter = true;
  } else if (
    !/[!#$%&*~_+=]/.test(password) &&
    nextPasswordValidation.hasSpecialCharacter
  ) {
    nextPasswordValidation.hasSpecialCharacter = false;
  }

  if (password?.length >= 8) {
    nextPasswordValidation.length = true;
  } else if (nextPasswordValidation.length && password?.length < 8) {
    nextPasswordValidation.length = false;
  }

  if (
    nextPasswordValidation.length &&
    nextPasswordValidation.hasNumber &&
    nextPasswordValidation.hasSpecialCharacter &&
    nextPasswordValidation.hasUpper
  ) {
    setPasswordIsValid(true);
  } else if (
    passwordIsValid &&
    (!nextPasswordValidation.length ||
      !nextPasswordValidation.hasNumber ||
      !nextPasswordValidation.hasSpecialCharacter ||
      !nextPasswordValidation.hasUpper)
  ) {
    setPasswordIsValid(false);
  }

  setPasswordValidation(nextPasswordValidation);
};

export default checkPasswordValidHelper;
